import { useCallback, useEffect, useState } from "react";

import { Button } from "../../../components/Button";
import { Drawer } from "../../../components/Drawer";
import { InputSearch } from "../../../components/InputSearch";
import { Label } from "../../../components/Label";
import { Radio } from "../../../components/Radio";

import { Loading } from "@components";
import debounce from "lodash.debounce";
import { If } from "shared/components/control-statements";
import { OlgaEnvironmentsAPI } from "../../../../providers/OlgaEnvironmentsAPI";
import { StandaloneCouponsAPI } from "../../../../providers/StandaloneCouponsAPI";
import styles from "../../../../styles/beneficios/CreateFolderDrawer.module.scss";

export default function ChangeBenefitFolderDrawer({
  benefit,
  visible,
  onClose,
  onBack,
  onLoadBenefits,
}) {
  const [folders, setFolders] = useState([]);
  const [destinationFolder, setDestinationFolder] = useState(null);
  const [moving, setMoving] = useState(false);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  useEffect(() => {
    if (visible) loadFolders();
  }, [visible]);

  const loadFolders = async () => {
    setLoading(true);
    const environmentConfigurations = (
      await OlgaEnvironmentsAPI.getConfigurations()
    ).getData({});
    const couponFolders = environmentConfigurations?.coupon_folders || [];
    setFolders(couponFolders);
    setLoading(false);
  };

  const moveFolder = async () => {
    setMoving(true);
    const moveResponse = await StandaloneCouponsAPI.updateCouponFolder(
      benefit.id,
      destinationFolder.id
    );

    if (moveResponse.getErrors([]).length > 0) {
      alert({ text: moveResponse.getErrors()[0] });
      return setMoving(false);
    }

    setMoving(false);
    onLoadBenefits();
  };

  const unlinkFolder = async () => {
    setMoving(true);
    const moveResponse = await StandaloneCouponsAPI.deleteCouponFolder(
      benefit.id
    );

    if (moveResponse.getErrors([]).length > 0) {
      alert({ text: moveResponse.getErrors()[0] });
      return setMoving(false);
    }

    setMoving(false);
    onLoadBenefits();
  };

  const filterFolder = () => {
    if (!debouncedSearchTerm) {
      return folders;
    }

    return folders.filter((folder) => {
      const name = folder.name.toLowerCase();
      const filterName = debouncedSearchTerm.toLowerCase();
      return name.includes(filterName);
    });
  };

  const debounceSearchTerm = useCallback(
    debounce((searchTerm) => {
      setDebouncedSearchTerm(searchTerm);
    }, 500),
    []
  );

  const filteredFolders = filterFolder(folders);

  return (
    <Drawer
      onClose={onClose}
      title="Mover benefício"
      visible={visible}
      showBackButton={true}
      backButton={onBack}
    >
      <div className={styles.createFolder}>
        <>
          <Label>Para que pasta você gostaria de mover o benefício?</Label>

          <InputSearch
            search
            value={searchTerm}
            occurrences={filteredFolders.length}
            className="mb-15"
            placeholder="Buscar por pasta..."
            prefix
            prefixWidth={20}
            onChange={(e) => {
              const value = e.target.value;
              setSearchTerm(value);
              debounceSearchTerm(value);
            }}
          />

          <If cond={loading}>
            <div className={styles.createdFolders}>
              <div className="h-100 d-flex align-center justify-center">
                <Loading />
              </div>
            </div>
          </If>

          <If cond={!loading}>
            <div className={styles.createdFolders}>
              {filteredFolders.map((folder) => (
                <div
                  className={styles.folder}
                  key={folder.id}
                  onClick={() => setDestinationFolder(folder)}
                >
                  <Radio
                    family="folder"
                    value={folder.id}
                    checked={destinationFolder ? destinationFolder.id : null}
                  >
                    {folder.name}
                  </Radio>
                </div>
              ))}
            </div>
          </If>

          <div className={styles.footer}>
            {destinationFolder && (
              <Button
                className="w-100 mb-15"
                onClick={moveFolder}
                disabled={moving}
                loading={moving}
                design="primary"
              >
                Salvar
              </Button>
            )}

            <Button className="w-100" onClick={unlinkFolder} disabled={moving}>
              Não quero agrupar benefício
            </Button>
          </div>
        </>
      </div>
    </Drawer>
  );
}
